<template>
  <div class="div5 cutbox">

      <div class="text1" data-id="主标题1" data-range="4,6">{{ info.titles[0] }}</div>
      <div class="text2" data-id="长特点1" data-range="6,12">{{ info.specialty[0] }}</div>


    <div class="text3"><img :src="info.image" alt=""></div>

      <div class="text4" data-id="长特点2" data-range="5,14">{{ info.specialty[1] }}</div>
      <div class="text5" data-id="公司简称" data-range="8,20">{{ info.company }}</div>
 
  </div>
</template>
<script>
export default {
  name: 'TUWEN005',
  props: {
    info: Object
  },
}
</script>
